import { NewsIndexClient } from 'hb-react/frontoffice/apps/NewsIndex/startup/NewsIndexClient';
import type { Config } from 'hb-react/frontoffice/apps/NewsIndex/types';

interface NewsAppClientProps {
  config: Config;
  topic?: { id: number };
}

const NewsAppClient = ({ config, topic }: NewsAppClientProps) => (
  <NewsIndexClient config={config} topic={topic} />
);

export default NewsAppClient;
